import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useEffect, useState } from "react";

dayjs.extend(duration);

export type Cutoff = Date | string | number | null;

const getTimeLeft = (cutoff: Cutoff) =>
  dayjs.duration(cutoff ? Math.max(dayjs(cutoff).diff(dayjs()), 0) : 0);

export type CutoffCountdownDuration = ReturnType<typeof getTimeLeft>;

export const useCutoffCountdown = (cutoff: Cutoff) => {
  const cutoffTimestamp = cutoff ? dayjs(cutoff).valueOf() : null;
  const [trackedCutoff, setTrackedCutoff] = useState(cutoffTimestamp);
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(cutoffTimestamp));

  if (cutoffTimestamp !== trackedCutoff) {
    setTrackedCutoff(cutoffTimestamp);
    setTimeLeft(getTimeLeft(cutoffTimestamp));
  }

  useEffect(() => {
    if (cutoffTimestamp === null) {
      return;
    }

    const updateTimeLeft = () => {
      const nextTimeLeft = getTimeLeft(cutoffTimestamp);
      setTimeLeft(nextTimeLeft);
      return nextTimeLeft;
    };

    if (updateTimeLeft().asMilliseconds() === 0) {
      return;
    }

    const interval = window.setInterval(() => {
      if (updateTimeLeft().asMilliseconds() === 0) {
        window.clearInterval(interval);
      }
    }, 1000);

    return () => window.clearInterval(interval);
  }, [cutoffTimestamp]);

  return timeLeft;
};
